<InactivityModal />
<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100 d-none d-lg-block">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100 scroll-container">
        <div class="card bg-white mt-2 rounded-5 border-0">
          <div class="card-header border-0 bg-transparent rounded-5 d-flex justify-content-between align-items-center">
            <h5 class="fw-500 mb-0">Business List</h5>
            <button class="btn btn-secondary text-white text-xxs rounded-3 btn-sm fw-normal" @click="openCreateModal">
              <i class='bx bx-plus'></i> Add Business
            </button>
          </div>
          <div class="card-body table-responsive">
            <table class="table text-xxs table-striped mt-3 bg-white">
              <thead class="bg-dark text-white">
                <tr>
                  <th>#</th>
                  <th>Business Name</th>
                  <th>Owner</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(business, index) in businesses" :key="business.id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ business.company_name }}</td>
                  <td>{{ business.base_profile.creater.first_name }} {{ business.base_profile.creater.last_name }}</td>
                  <td>{{ business.email }}</td>
                  <td>{{ business.tell_number }}</td>
                  <td>
                    <button class="btn btn-secondary btn-sm text-xxs rounded-3 mx-1 shadow" @click="view_profile(business)">View</button>
                    <button class="btn btn-success btn-sm text-xxs rounded-3 mx-1 shadow d-none" >Edit</button>
                    <button class="btn btn-danger btn-sm text-xxs rounded-3 mx-1 shadow d-none">Delete</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

